export default __webpack_public_path__ + "static/1-93f26bfe69ab8156c5e262b5d70cedd8.jpg";